import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

function* loadSyncBlocks() {
  try {
    const res = yield fetcher.get("sync_blocks");
    yield put(actions.loadSyncBlocks.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadSyncBlocks.failure(getErrorMsg(error)));
  }
}

function* toggleSyncBlock(action) {
  try {
    const { branchId } = action.payload;
    const res = yield fetcher.post(`sync_blocks/${branchId}/toggle`);
    yield put(actions.toggleSyncBlock.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.toggleSyncBlock.failure(getErrorMsg(error)));
  }
}

export default function* watchSyncBlocks() {
  yield all([
    takeEvery(actions.LOAD_SYNC_BLOCKS.REQUEST, loadSyncBlocks),
    takeEvery(actions.TOGGLE_SYNC_BLOCK.REQUEST, toggleSyncBlock)
  ]);
}

export const watchSyncBlock = [watchSyncBlocks];
